import CryptoJS from "crypto-js";
import config, { S3_GYL_ICONS } from "./config";
import { fiatVendors, LOCALSTORAGE_LANGUAGE_KEY, paymentOptions, transferType } from "./constants";
import packageJson from '../../package.json';
import * as Sentry from "@sentry/browser";
import { languages } from "../locale";

var WAValidator = require("wallet-address-validator/dist/wallet-address-validator");

export const Decrypt = (data) => {
  const decrypted = CryptoJS.AES.decrypt(data, config.SECRET_KEY).toString(
    CryptoJS.enc.Utf8
  );
  return decrypted;
};

export const Encrypt = (data) => {
  const stringData = JSON.stringify(data);
  const encrypted = CryptoJS.AES.encrypt(
    stringData,
    config.SECRET_KEY
  ).toString();
  return encrypted;
};
export const renderIfElse = (condition, component1, component2) => {
  if (condition) {
    return component1;
  } else {
    return component2;
  }
};

export const formatNumber = (number) => {
  return Number(parseFloat(number).toFixed(2)).toLocaleString("en", {
    minimumFractionDigits: 2,
  });
};

export const formatCryptoDecimals = (number) => {
  const value = number?.toString() || "0";
  const decimals = value.split(".")[1];
  if (decimals && decimals !== undefined && decimals.length > 6) {
    const decimalValue = parseFloat(value).toFixed(6);
    return decimalValue;
  }
  return value;
};
/**
 *
 * @param {<merchant object>} merchant
 * @returns string
 */
export const getMerchantName = (merchant) => {
  if (merchant.shopData && merchant.shopData.companyName) {
    return merchant.shopData.companyName;
  } else return merchant.fullname;
};

export const cleanCache = (version) => {
  caches.keys().then((names) => {
    names.forEach((name) => {
      caches.delete(name);
    });
  });
  clearLocalStorage();
  if (version) {
    localStorage.setItem("version", version);
  }
  window.location.reload();
};


export const validator = (text, cryptoCurrency) => {
  try {
    if (['SOL', 'MATIC', 'POL'].includes(cryptoCurrency)) return true;
    return WAValidator.validate(text, cryptoCurrency);
  } catch (err) {
    if (["USDC", "USDT"].indexOf(cryptoCurrency) > -1) {
      return WAValidator.validate(text, "ETH");
    }
    return false;
  }
};

export const isBlockedUser = (user, status) => {
  // eslint-disable-next-line eqeqeq
  return user.kycStatus == 3 || user.kycStatus == 5;
};

export const isFiatTransaction = (service) => {
  return transferType.fiat.includes(service);
}

export const appVersionCheck = async () => {
  try {
    const appVersion = localStorage.getItem('app-version');
    const currentAppVersion = packageJson.version;
    if (!appVersion) {
      // cleanCache();
      // clearLocalStorage();
      localStorage.setItem('app-version', currentAppVersion);
      // window.location.reload();
    } else if (appVersion && currentAppVersion !== appVersion) {
      cleanCache();
      clearLocalStorage();
      localStorage.setItem('app-version', currentAppVersion);
      window.location.reload();
    }
  } catch (err) {
    console.log(err.message);
  }
}

export const clearLocalStorage = () => {
  let rememberMeKeys = [
    "email_payee",
    "version",
    "walletaddress-ETH",
    "walletaddress-USDT",
    "walletaddress-USDC",
    "walletaddress-BTC",
    "new_user_email",
    "new_user",
    "app-version",
    "mfa-pop",
    "getting-started",
    "app-version",
    "statement-pop",
  ];
  let localStorageData = {};
  for (let i = 0; i < localStorage.length; i++) {
    localStorageData[localStorage.key(i)] = localStorage.getItem(
      localStorage.key(i)
    );
  }

  localStorage.clear();

  for (let rememberMeKey of rememberMeKeys) {
    if (localStorageData[rememberMeKey]) {
      localStorage.setItem(rememberMeKey, localStorageData[rememberMeKey]);
    }
  }
  return;
}


export const trimText = (text, maxLength) => {
  if (text.length > maxLength) {
    return text.substring(0, maxLength) + "...";
  }
  return text;
}

export const removeDynamicPart = (path) => {

  // Split the path by '/'
  const parts = path.split('/');

  // Find the index of the dynamic part (e.g., UUID)
  const uuidIndex = parts.findIndex(part => part.length > 5 && part.match(/^[0-9a-f]{8}-(?:[0-9a-f]{4}-){3}[0-9a-f]{12}$/));
  // Remove the dynamic part from the path
  let pathWithoutUuid = path;
  if (uuidIndex > 0) {
    pathWithoutUuid = parts.slice(0, uuidIndex).join('/');
  }
  if (pathWithoutUuid.includes('invite')) {
    const regexPattern = /\/[^/]+$/;
    return pathWithoutUuid?.replace(regexPattern, '')
  }

  return pathWithoutUuid;
}

export const removeNonCryptoHelp = (data, enabled) => {
  let values = data;
  if (!enabled && data) {
    values = data.filter(val => !val.removeable)
  }
  return values;
}

export const extractEthereumAddress = (inputString) => {
  // Regular expression to match Ethereum addresses
  const regex = /(0x[a-fA-F0-9]{40})/;

  // Use match to find the first occurrence of the address in the string
  const match = inputString.match(regex);

  // If a match is found, return the Ethereum address, otherwise return null
  return match ? match[0] : null;
}

export const initalizeUserForLoggers = async (data) => {
  try {
    Sentry.setUser({ email: data.email });
  } catch (err) {
    console.log(err.message);
  }
}
export const persistLanguagePreference = (language) => {
  localStorage.setItem(LOCALSTORAGE_LANGUAGE_KEY, language);
}

export const retrieveLanguagePreference = () => {
  try {
    const language = localStorage.getItem(LOCALSTORAGE_LANGUAGE_KEY);

    //validate the language
    const languageKeys = Object.keys(languages);
    if (language && languageKeys.includes(language)) {
      return language;
    } else {
      return languages.EN.id;
    }
  } catch (error) {
    return languages.EN.id;
  }

}


export const checkPockytEnabled = (fiatService) => {
  return fiatVendors.includes(fiatService?.serviceName);
}

export const getCurrentTitles = (active, payment, t, bankFlag) => {
  switch (active) {
    case 0:
      return `${t("selectAmount")}`;
    case 1:
      return `${t("selectPayment")}`;
    case 2:
      if (payment === paymentOptions.crypto)
        return `${t("selectCurrency")}`;
      else if (payment === paymentOptions.masspay)
        return t("Select country");
      else if (fiatVendors.includes(payment)) {
        if (bankFlag) {
          return t("pockyt.step1");;
        }
        return t("bankAccount")
      }
      break;
    case 3:
      if (payment === paymentOptions.crypto)
        return `${t("addWallet")}`;
      else if (payment === paymentOptions.masspay)
        return t("Transfer options");
      else if (fiatVendors.includes(payment)) {
        if (bankFlag) {
          return t("addBankAccount");
        }
        return t("Summary")
      }
      break;
    case 4:
      if (payment === paymentOptions.crypto) return;
      else if (payment === paymentOptions.masspay) return t("Transfer options");
      else if (fiatVendors.includes(payment)) {
        if (bankFlag) {
          return t("Summary");
        } else {
          return t("Summary")
        }
      }
      break;
    case 5:
      if (payment === paymentOptions.crypto) return;
      else if (payment === paymentOptions.masspay) return t("selectCurrency");
      break;
    case 6:
      if (payment === paymentOptions.crypto) return;
      else if (payment === paymentOptions.masspay) return t("Fill the form");
      break;
    case 7:
      if (payment === paymentOptions.crypto) return;
      else if (payment === paymentOptions.masspay) return t("Summary")
      break
    default:
      return "";
  }
};

export const getBackTitles = (active, skip, payment, t, bankFlag) => {
  const constant = active;
  if (skip.includes(active)) {
    active = active - 1;
  }
  if (skip.includes(active) && constant === 4) {
    active = active - 1;
  }
  switch (active) {
    case 0:
      return `${t("selectAmountBack")}`;
    case 1:
      return `${t("selectPaymentBack")}`;
    case 2:
      if (payment === paymentOptions.crypto)
        return `${t("selectCurrencyBack")}`;
      else if (payment === paymentOptions.masspay)
        return t("Select country");
      else if (fiatVendors.includes(payment)) {
        if (bankFlag) {
          return t("pockyt.step1");
        }
        return t("bankAccount")
      }
      break;
    case 3:
      if (payment === paymentOptions.crypto)
        return `${t("addWalletBack")}`;
      else if (payment === paymentOptions.masspay)
        return t("Transfer options");
      else if (fiatVendors.includes(payment)) {
        if (bankFlag) {
          return t("addBankAccount");
        }
        return t("bankAccount")
      }
      break;
    case 4:
      if (payment === paymentOptions.crypto) return;
      else if (payment === paymentOptions.masspay)
        return t("Transfer options");
      else if (fiatVendors.includes(payment)) {
        if (bankFlag) {
          return t("addbankdetails");
        } else {
          return t("addbankdetails");
        }
      }
      break;
    case 5:
      if (payment === paymentOptions.crypto) return;
      else if (payment === paymentOptions.masspay) return t("Select currency");
      break;
    case 6:
      if (payment === paymentOptions.crypto) return;
      else if (payment === paymentOptions.masspay) return t("Fill the form back");
      break;
    case 7:
      if (payment === paymentOptions.crypto) return;
      else if (payment === paymentOptions.masspay) return t("Summary");
      break;
    default:
      return "";
  }
};

export const getFiatIcon = (icon) => {
  try {
    const Logo = `${S3_GYL_ICONS}/fiat/${icon.toLowerCase()}.svg`;
    return Logo;
  } catch (err) {
    return "";
  }
};

export const maskDigits = (input) => {
  if(!input) return '';
  // Convert input to a string to handle both string and number inputs
  const digits = input.toString();

  // Get the last 4 digits
  const lastFour = digits.slice(-4);

  // Create the masked part with 3 * characters followed by the last 4 digits
  const masked = '***' + (lastFour || '');

  return masked;
}

export const isKycVerified = (user)=>{
  if(!user){
    return false
  }
  if(user.meta && user.meta?.isExternalPayee && user.meta?.disableComplianceReview){
    return true
  }
return Number(user.kycStatus) === 2
}

export const replaceLabels = (label) => {
  // 'Purpose of Bank Account'
  if (label === 'Purpose of Bank Account') {
    return 'Bank Account Type';
  }
  return label;
}
export const showVerificationPage = (user) => {
  if(!user) {
    return false;
  }
  const { kycMismatch, kycStatus } = user;
  const status = Number(kycStatus);
  if(kycMismatch || status === 4 || status === 5 || status === 1 || status === 2) {
    return false;
  }
  return true;
}

export const doesBankRequireVerification = (type) => {
  const verificationRequired = [paymentOptions.pockyt];
  return verificationRequired.indexOf(type) > -1;
}